import React from "react";

import TransactionTable from "./TransactionTable";
import useMyTransactions from "../../../hooks/useMyTransactions";

const Purchases = () => {
    const { purchases, loading, error, userId } = useMyTransactions();

    return (
        <TransactionTable
            title="Mes achats"
            transactions={purchases}
            loading={loading}
            error={error}
            userId={userId}
            emptyText="Aucun achat pour le moment"
            counterpartTitle="Vendeur"
        />
    );
};

export default Purchases;
